/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Blank, Effect, MaterialTechTransfer, Nullable, Pagination, Setter } from "../../utils/Interfaces";
import { getHandler, postHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AxiosResponse } from "axios";

export function createMaterialTechTransfer(
    fromStorageLocationId: number,
    toStorageLocationId: number,
    materialId: number,
    amount: number,
    notes: Nullable<string>,
    dispatch: Dispatch<AnyAction>,
    onMaterialTransferCreated: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/inventory/tech-transfer/create/${fromStorageLocationId}/${toStorageLocationId}/${materialId}/${amount}`,
        { notes: notes },
        dispatch,
        () => onMaterialTransferCreated(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function cancelMaterialTechTransfer(
    materialTransferId: number,
    notes: string,
    dispatch: Dispatch<AnyAction>,
    onMaterialTransferCancelled: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/inventory/tech-transfer/cancel/${materialTransferId}`,
        { notes: notes },
        dispatch,
        () => onMaterialTransferCancelled(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function acceptMaterialTechTransfer(
    materialTransferId: number,
    dispatch: Dispatch<AnyAction>,
    onMaterialTransferAccepted: Effect,
    setLoading: Setter<boolean>
): void {
    postHandler<Blank, Blank>(
        `/api/inventory/tech-transfer/accept/${materialTransferId}`,
        {},
        dispatch,
        () => onMaterialTransferAccepted(),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function updateReceivingMaterials(
    dispatch: Dispatch<AnyAction>,
    setAssets: Setter<MaterialTechTransfer[]>,
    setLoading: Setter<boolean>
): void {
    getHandler<Pagination<MaterialTechTransfer>>(
        "/api/inventory/tech-transfer/list/receiving",
        dispatch,
        (response: AxiosResponse<Pagination<MaterialTechTransfer>, any>) => setAssets(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}

export function updatePendingMaterials(
    dispatch: Dispatch<AnyAction>,
    setAssets: Setter<MaterialTechTransfer[]>,
    setLoading: Setter<boolean>
): void {
    getHandler<Pagination<MaterialTechTransfer>>(
        "/api/inventory/tech-transfer/list/pending",
        dispatch,
        (response: AxiosResponse<Pagination<MaterialTechTransfer>, any>) => setAssets(response.data.results),
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
